module.exports = __webpack_public_path__ + "static/media/17.24e9db03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/17.jpg
// module id = 550
// module chunks = 0